import $ from 'jquery';

$('.simple-select').on('change', 'select', function(){
    window.location = $(this).val();
});